import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1388.388,1178.604 C1423.428,1260.924 1426.308,1356.204 1397.028,1461.924 C1336.668,1677.924 1197.708,1756.644 1091.628,1784.604 C1049.508,1795.764 1005.948,1800.804 962.028,1800.804 C770.508,1800.804 571.788,1704.564 459.348,1592.844 L459.348,1592.844 L408.468,1538.244 L496.308,1456.524 L545.508,1509.324 C660.228,1623.324 885.228,1715.124 1060.908,1668.564 C1171.068,1639.524 1245.348,1559.124 1281.468,1429.644 C1303.548,1349.844 1302.468,1283.124 1277.988,1225.764 L1277.988,1225.764 Z M758.472,137.928 C985.152,76.248 1257.192,183.168 1398.312,314.928 L1398.312,314.928 L1316.472,402.648 C1199.832,293.928 965.592,205.728 790.032,253.728 C683.952,282.528 612.432,356.808 577.512,474.408 C503.112,724.728 713.232,809.568 995.592,894.408 C1070.232,916.848 1134.792,936.888 1181.952,962.208 L1181.952,962.208 L1919.952,962.208 L1919.952,1082.208 L-0.048,1082.208 L-0.048,962.208 L814.872,962.208 C601.632,885.288 370.272,750.288 462.432,440.088 C509.352,282.408 611.712,177.888 758.472,137.928 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStrikethroughLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStrikethroughLine, _Component);

  var _super = _createSuper(IconStrikethroughLine);

  function IconStrikethroughLine() {
    _classCallCheck(this, IconStrikethroughLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStrikethroughLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStrikethrough",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStrikethroughLine.displayName = "IconStrikethroughLine";
  return IconStrikethroughLine;
}(Component);

IconStrikethroughLine.glyphName = 'strikethrough';
IconStrikethroughLine.variant = 'Line';
IconStrikethroughLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStrikethroughLine;
export { IconStrikethroughLine };